import React from 'react';
import type { RefObject } from 'react';

interface ThermalStageProps {
  stageRef: RefObject<HTMLDivElement | null>;
  screwRef: RefObject<HTMLDivElement | null>;
  getContent: (key: string) => string;
}

// Fixed full-viewport stage holding the sparks layer and the single screw image
// whose camera transform is driven by useScrewAnimation. Images are DB-backed
// (hero-sparks-image / hero-screw-image) and edited from the hero's edit panel.
const ThermalStage: React.FC<ThermalStageProps> = ({ stageRef, screwRef, getContent }) => (
  <div className="thermal-stage" aria-hidden="true" ref={stageRef}>
    <img
      className="machining-sparks"
      src={getContent('hero-sparks-image')}
      alt=""
      width={1536}
      height={1024}
    />
    <div className="screw-object" ref={screwRef}>
      <img
        src={getContent('hero-screw-image')}
        alt=""
        width={1536}
        height={1024}
        fetchPriority="high"
      />
    </div>
  </div>
);

export default ThermalStage;
